import { render, staticRenderFns } from "./headerBlank.vue?vue&type=template&id=6f22fcf6&scoped=true&"
import script from "./headerBlank.vue?vue&type=script&lang=js&"
export * from "./headerBlank.vue?vue&type=script&lang=js&"
import style0 from "./headerBlank.vue?vue&type=style&index=0&id=6f22fcf6&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f22fcf6",
  null
  
)

export default component.exports